import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { PasswordTextBox } from '../TextBox/PasswordTextBox'
import { Button, ButtonThemeType } from '../Button'
import { Form } from './index'
import { ButtonType } from '../Button/ButtonType.constants'
import { changePassword } from '../../states/currentUser/actions'

const ChangePasswordForm = () => {
  const dispatch = useDispatch()
  const [formFields, setFormFields] = useState({})
  return (
    <Form
      formFields={formFields}
      onChange={(ff) => setFormFields(ff)}
      onSubmit={() => {
        dispatch(changePassword(formFields.oldPassword, formFields.newPassword))
      }}
    >
      <PasswordTextBox
        labelText="Old Password"
        name="oldPassword"
        validation="password"
      />
      <PasswordTextBox
        labelText="New Password"
        name="newPassword"
        validation="password"
      />
      <Button
        label="Update Password"
        theme={ButtonThemeType.PRIMARY}
        type={ButtonType.SUBMIT}
      >
        Update Password
      </Button>
    </Form>
  )
}

export { ChangePasswordForm }
